import { createColumnHelper } from '@tanstack/react-table';

interface NomineeApplication {
  id: string;
  name: string;
  email: string;
  contactInfo: string;
  address: string;
  additionalInfo: {
    secondaryInfo: {
      email: string;
      contactInfo: string;
    };
  };
  createdAt: string;
  status?: string;
}

const columnHelper = createColumnHelper<NomineeApplication>();

export const getColumns = () => [
  columnHelper.accessor('name', {
    header: 'Name',
    size: 150,
    cell: (props) => <div className='text-sm font-medium text-neutralColor-dark'>{props.getValue()}</div>,
  }),
  columnHelper.accessor('email', {
    header: 'Email',
    size: 200,
    cell: (props) => <div className='text-sm text-neutralColor-medium'>{props.getValue()}</div>,
  }),
  columnHelper.accessor('contactInfo', {
    header: 'Phone Number',
    size: 150,
    cell: (props) => <div className='text-sm text-neutralColor-medium'>{props.getValue()}</div>,
  }),
  columnHelper.accessor('address', {
    header: 'Address',
    size: 250,
    cell: (props) => <div className='text-sm text-neutralColor-medium max-w-xs truncate'>{props.getValue()}</div>,
  }),
  columnHelper.accessor('createdAt', {
    header: 'Submitted',
    size: 120,
    cell: (props) => (
      <div className='text-sm text-neutralColor-medium'>{props.getValue() ? new Date(props.getValue()).toLocaleDateString() : '-'}</div>
    ),
  }),
  columnHelper.accessor('status', {
    header: 'Status',
    size: 100,
    cell: (props) => {
      const status = props.getValue() || 'Pending';
      const statusClasses = {
        approved: 'bg-green-100 text-green-800',
        rejected: 'bg-red-100 text-red-800',
        pending: 'bg-yellow-100 text-yellow-800',
      };

      return (
        <span
          className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
            statusClasses[status.toLowerCase() as keyof typeof statusClasses] || statusClasses.pending
          }`}
        >
          {status}
        </span>
      );
    },
  }),
];
